import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

import { ApartmentDto } from "@/api/models/coverage.model";
import { CustomerHandoverProcessDto } from "@/api/models/customer/customerHandover.model";

export interface HandoverState {
	apartment: ApartmentDto;
	handoverType?: string;
	process?: CustomerHandoverProcessDto;
	loading: boolean;
	error?: string;
}

export const handoverInitialState = (): HandoverState => {
	return {
		apartment: {
			apartmentId: "-1",
			floor: "",
			door: "",
			stair: "",
			network: ""
		} as ApartmentDto,
		handoverType: undefined,
		process: undefined,
		loading: false,
		error: undefined
	};
};

const state: HandoverState = handoverInitialState();

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
